export enum MESSAGES {
  WIN = "You win!",
  LOST = "Better Luck Next time!",
  TIME_UP = "Time Up!",
  CHOOSE_DIFFICULTY = "Choose Difficulty",
  EMPTY_STRING = "",
}
